package com.deange.nastychristmas.model

import kotlinx.serialization.Serializable

@Serializable
data class Player(
  val name: String,
)
